import store from '@/store'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'
import { getNccCategoriesColumnGroups } from './nccCategoriesColumnGroups'
import { buildNccCategoriesGroupDef, buildNccCategoriesColumnDef } from './nccCategoriesColumnsDef'
import {
  formatConstructedError,
  defaultChemicalKey,
  defaultResultKey,
  defaultResultsKey,
} from '@/utils/responseNormalizers'
import { createMetadataHelpers } from '../metadata'

const groupedKeys = get(modelStateRegistry, 'groupedModel.keys')
const namespace = 'nccCategories'
const { getName, getDescription, getEndpointIds } = createMetadataHelpers(`${namespace}/${groupedKeys.getMetadata}`)

const getNccCategoriesAdapter = (modelId) => ({
  [modelId]: {
    predictionsKey: `${defaultResultKey}.categories`,
    chemicalKey: defaultChemicalKey,
    errorKey: 'error',
    categoryId: 'categorizationModels',
    getResults: () => store.getters[`${namespace}/${groupedKeys.getResultsForModel}`](modelId)?.[defaultResultsKey],
    getIsLoading: () => store.getters[`${namespace}/${groupedKeys.getIsLoadingForModel}`](modelId),
    getIsAborted: () => store.getters[`${namespace}/${groupedKeys.getIsAbortedForModel}`](modelId),
    fetch: (chemicals) => store.dispatch('nccCategories/predict', { structures: chemicals, modelId }),
    reset: () => store.commit(`${namespace}/${groupedKeys.RESET_STATE_FOR_MODEL}`, modelId),
    abort: () => store.commit(`${namespace}/${groupedKeys.ABORT_CURRENT_FETCH_FOR_MODEL}`, { modelId }),
    getParameters: () => getNccCategoriesColumnGroups(),
    getGroupDef: buildNccCategoriesGroupDef,
    getColumnDefBuilder: buildNccCategoriesColumnDef,
    getName: () => getName(modelId),
    getDescription: () => getDescription(modelId),
    formatError: (error) => formatConstructedError(error),
  },
})

const getNccCategoriesAdapters = () =>
  getEndpointIds().reduce((acc, modelId) => ({ ...acc, ...getNccCategoriesAdapter(modelId) }), {})

export { getNccCategoriesAdapters }
